import React from 'react';

const BlogPost = ({ title, date, author, excerpt, imageUrl }) => (
  <div className="bg-white shadow-lg rounded-lg overflow-hidden flex flex-col h-full">
    <img className="w-full h-48 object-cover" src={imageUrl} alt={title} />
    <div className="p-6 flex flex-col flex-grow">
      <h2 className="text-2xl font-bold text-gray-800 mb-2">{title}</h2>
      <p className="text-gray-600 text-sm mb-4">By {author} | {date}</p>
      <p className="text-gray-700 mb-4 flex-grow">{excerpt}</p>
      <div className="mt-auto">
        <a href="/" className="text-purple-600 hover:text-purple-800 font-semibold">Read More →</a>
      </div>
    </div>
  </div>
);

const Blog = () => {
  const blogPosts = [
    {
      id: 1,
      title: "Our Favorite Reads of 2024",
      date: "October 1, 2024",
      author: "Emma Watson",
      excerpt: "As we reflect on another year of fantastic literature, our book club members share their top picks from our 2024 reading list. From gripping mysteries to heartwarming romances, discover the books that left a lasting impression on us.",
      imageUrl: "https://images.unsplash.com/photo-1512820790803-83ca734da794?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
    {
      id: 2,
      title: "Author Spotlight: Jane Doe",
      date: "September 15, 2024",
      author: "Sophia Miller",
      excerpt: "Get to know Jane Doe, the brilliant mind behind our latest book club pick. In this exclusive interview, Jane shares her writing process, inspirations, and what's next in her literary journey.",
      imageUrl: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
    {
      id: 3,
      title: "5 Tips for a Successful Book Club Discussion",
      date: "September 1, 2024",
      author: "Olivia Johnson",
      excerpt: "Whether you're a book club veteran or just starting out, these five tips will help you foster engaging and insightful discussions. Learn how to create an inclusive environment and dive deep into your chosen books.",
      imageUrl: "https://images.unsplash.com/photo-1530490125459-847a6d437825?ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80"
    },
  ];

  return (
    <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
      <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Munich Girls Book Club Blog</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {blogPosts.map(post => (
          <BlogPost key={post.id} {...post} />
        ))}
      </div>
    </div>
  );
};

export default Blog;